export default [
  {
    title: 'Home',
    icon: 'HomeIcon',
    route: 'apps-home',
    // tag: '2',
    tagVariant: 'light-warning',
  },
]
